export default __webpack_public_path__ + "static/B0120-d2968691f96d5d0cfda03bb49b6f702f.png";